//#region src/types/index.ts
var e = /* @__PURE__ */ function(e) {
	return e.General = "general", e.LocalStorage = "local-storage", e.Collector = "collector", e.Replicator = "replicator", e.AdsRouter = "ads-router", e.Syncer = "syncer", e.Analytics = "analytics", e.CloudManager = "cloud-manager", e.EdgeBus = "edge-bus", e.Variables = "variables", e.Triggers = "triggers", e;
}({}), t = /* @__PURE__ */ function(e) {
	return e.Configuration = "configuration", e.Tags = "tags", e.ConditionTrigger = "condition-trigger", e.Measurements = "measurements", e.CustomSettings = "custom-settings", e;
}({});
//#endregion
export { e as n, t };

//# sourceMappingURL=types-CsIxq0a2.js.map